module.exports = __webpack_public_path__ + "static/media/jpg.8e52a9ef.png";